const AP: Pick<
  Window['AP'],
  'sizeToParent' | 'flag' | 'events' | 'navigator' | 'jira'
> = {
  sizeToParent() {
    window.AP.sizeToParent();
  },
  flag: {
    create: function (options) {
      return window.AP.flag.create(options);
    },
  },
  events: {
    emit: function (name) {
      window.AP.events.emit(name);
    },
    on: function (name, listener) {
      window.AP.events.on(name, listener);
    },
    onPublic: function (name, listener) {
      window.AP.events.onPublic(name, listener);
    },
  },
  navigator: {
    go: function (target, context) {
      window.AP.navigator.go(target, context);
    },
    reload: function () {
      window.AP.navigator.reload();
    },
  },
  jira: {
    openCreateIssueDialog: function (callback, params) {
      return window.AP.jira.openCreateIssueDialog(callback, params);
    },
  },
};

export default AP;
